import { mountDrumMachine } from "./drum-machine";
import { mountCodeReveal } from "./get-started";
import { mountHero } from "./hero";
import { mountUseCases } from "./use-cases";
import type { DemoTermElement } from "./shared";

type Cleanup = () => void;

export function mountApp(root: HTMLElement): Cleanup {
  root.innerHTML = `
    <div class="page">
      <section class="section">
        <div class="hero-header">
          <div class="hero-title">1ch</div>
          <div class="hero-sub">Terminal-density UI for the web component stack</div>
          <div class="hero-cmd"><span class="prompt">$ </span>bun add 1ch</div>
        </div>
        <term-ui id="hero-term" width="80" mode="dark" class="terminal"></term-ui>
      </section>

      <section class="section">
        <div class="section-header">
          <div class="label">this much code</div>
        </div>
        <div class="row">
          <term-ui id="code-term" width="56" mode="dark" class="terminal"></term-ui>
          <term-ui id="output-term" width="48" mode="dark" class="terminal"></term-ui>
        </div>
      </section>

      <section class="section">
        <div class="section-header">
          <div class="label">what you can build</div>
        </div>
        <div class="row">
          <div class="use-case">
            <term-ui id="ai-term" width="48" mode="dark" class="terminal"></term-ui>
            <div class="use-case-label">Streaming LLM responses with full Markdown rendering.</div>
          </div>
          <div class="use-case">
            <term-ui id="dev-term" width="48" mode="dark" class="terminal"></term-ui>
            <div class="use-case-label">File trees, syntax highlighting, and code blocks out of the box.</div>
          </div>
        </div>
      </section>

      <section class="section">
        <div class="section-header">
          <div class="label">INTERACTIVE</div>
          <div class="sublabel">click the grid</div>
        </div>
        <term-ui id="drum-term" width="64" mode="dark" class="terminal"></term-ui>
      </section>

      <footer class="footer">
        <div class="hero-cmd"><span class="prompt">$ </span>bun add 1ch</div>
        <div class="cta-links">
          <a href="/docs">Docs</a>
          <span class="dot">/</span>
          <a href="/repl">REPL</a>
          <span class="dot">/</span>
          <a href="https://github.com/TwoAbove/1ch">GitHub</a>
          <span class="dot">/</span>
          <a href="https://www.npmjs.com/package/1ch">npm</a>
        </div>
      </footer>
    </div>
  `;

  const heroTerm = root.querySelector<DemoTermElement>("#hero-term");
  const codeTerm = root.querySelector<DemoTermElement>("#code-term");
  const outputTerm = root.querySelector<DemoTermElement>("#output-term");
  const aiTerm = root.querySelector<DemoTermElement>("#ai-term");
  const devTerm = root.querySelector<DemoTermElement>("#dev-term");
  const drumTerm = root.querySelector<DemoTermElement>("#drum-term");

  if (!heroTerm || !codeTerm || !outputTerm || !aiTerm || !devTerm || !drumTerm) {
    throw new Error("Failed to initialize demo: missing term-ui nodes");
  }

  const cleanups: Cleanup[] = [];
  cleanups.push(mountHero(heroTerm));
  mountCodeReveal(codeTerm, outputTerm);
  cleanups.push(mountUseCases(aiTerm, devTerm));
  cleanups.push(mountDrumMachine(drumTerm));

  return () => {
    for (const cleanup of cleanups) cleanup();
  };
}
